import {Component, ViewChild} from '@angular/core';
import {IonicPage, NavParams, PopoverController, Slides, ViewController} from 'ionic-angular';
import {Photo, Sector} from "../../models/data.model";
import {DataProvider} from "../../providers/data/data";
import {RoutePathViewerComponent} from "../../components/route-path-viewer/route-path-viewer";
import {ListRoutesSectorPage} from "../list-routes-sector/list-routes-sector";

@IonicPage()
@Component({
  selector: 'page-photos-routes-viewer',
  templateUrl: 'photos-routes-viewer.html',
})
export class PhotosRoutesViewerPage {

  @ViewChild(RoutePathViewerComponent) routePathViewer: RoutePathViewerComponent;
  @ViewChild(Slides) slides: Slides;
  siteId: number;
  sectorId: number;
  isPoiOptional: boolean = true;
  photosRoutes: Photo[] = [];

  constructor(public viewCtrl: ViewController,
              public navParams: NavParams,
              private data: DataProvider,
              public popoverCtrl: PopoverController) {
    this.siteId = this.navParams.get('siteId');
    this.sectorId = this.navParams.get('sectorId');
    let photos: Photo[] = this.navParams.get('photos');
    this.photosRoutes = this.getSector().photoPaths.map(photoPath => {
      return {
        name: photoPath.photo,
        url: photos.find(photo => {
          return photo.name == photoPath.photo
        }).url
      }
    });
  }

  protected listRoutes() {
    this.popoverCtrl.create(ListRoutesSectorPage, {
      siteId: this.siteId,
      sectorId: this.sectorId
    }).present().catch();
  }

  protected togglePoiOptional(): void {
    this.isPoiOptional = !this.isPoiOptional;
  }

  protected getSector(): Sector {
    return this.data.getSector(this.siteId, this.sectorId);
  }

  protected closeModal(): void {
    this.viewCtrl.dismiss().catch();
  }

  protected getSlidesPerView() {
    if (this.getPhotosPreview().length > 5) return 5;
    return this.getPhotosPreview().length;
  }

  protected getPhotosPreview(): Photo[] {
    return this.photosRoutes;
  }

  protected isPhotoSelected(): boolean {
    return this.getCurrentPhoto() && this.getCurrentPhoto().name.length > 0;
  }

  protected isThisPhotoSelected(index: number) {
    return this.slides.getActiveIndex() === index;
  }

  protected showSlide(i) {
    this.slides.slideTo(i, 200);
  }

  protected previousPhoto() {
    this.slides.slidePrev();
    this.centerRoutePath();
  }

  protected nextPhoto() {
    this.slides.slideNext();
    this.centerRoutePath();
  }

  protected centerRoutePath(): void {
    this.routePathViewer.initZoom(true);
  }

  protected getCurrentPhoto(): Photo {
    return this.getPhotosPreview()[this.slides.getActiveIndex()];
  }
}



// WEBPACK FOOTER //
// ./src/pages/photos-routes-viewer/photos-routes-viewer.ts